import { render, staticRenderFns } from "./Plans.vue?vue&type=template&id=15149d43&"
import script from "./Plans.vue?vue&type=script&lang=js&"
export * from "./Plans.vue?vue&type=script&lang=js&"
import style0 from "./Plans.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports